import React, {FC, useEffect, useState} from "react";
import CardCategory2 from "components/CardCategoryMarkets/CardCategory2";
import Heading from "components/Heading/Heading";

import {Currency} from "data/types";
import Input from "../../components/Input/Input";



export interface SectionGridCategoryBoxMarketsProps {
    categories?: Currency[];
    headingCenter?: boolean;
    categoryCardType?: "card1" | "card2" | "card3" | "card4" | "card5";
    className?: string;
}


const SectionGridCategoryBoxMarkets: FC<SectionGridCategoryBoxMarketsProps> = ({
                                                                                       categories ,
                                                                                       categoryCardType = "card2",
                                                                                       headingCenter = true,
                                                                                       className = "",
                                                                                     }) => {
  let CardComponentName = CardCategory2;
  const [timestamp, setTimestamp] = useState("");
  switch (categoryCardType) {
    case "card2":
      CardComponentName = CardCategory2;
  }

  useEffect(() => {
    setTimestamp(new Date().toLocaleString());
    const timestampInterval = setInterval(() => setTimestamp(new Date().toLocaleString()), 10000);
    return () => {
      clearInterval(timestampInterval);
    }
  })

  return (
    <div className={`SectionGridCategoryBoxMarkets relative ${className}`}>
      <Heading desc={`Last Updated: ${timestamp}`} isCenter={headingCenter}>
        Crypto Currency Markets
      </Heading>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5 sm:gap-6 md:gap-8">
        {categories?.map((item, i) => (
          <CardComponentName
            index={i < 3 ? `#${i + 1}` : undefined}
            key={item.id}
            taxonomy={item}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionGridCategoryBoxMarkets;
